module.exports = __webpack_public_path__ + "static/media/MainBg.7711e85f.jpg";